import { render, staticRenderFns } from "./deductions.vue?vue&type=template&id=54f13d8b"
import script from "./deductions.vue?vue&type=script&lang=js"
export * from "./deductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports